var map = {
	"./de.json": "1506",
	"./en.json": "1360",
	"./es.json": "2941",
	"./fr.json": "8d07",
	"./ga.json": "7a4c",
	"./hu.json": "53f8",
	"./is.json": "d239",
	"./ru.json": "082b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b67d";